import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {EntityType} from 'nutshell-graphql-types';
import type {
    CreateCustomField as CreateCustomFieldMutation,
    CreateCustomFieldPerPipelineVariables as CreateCustomFieldVariables,
} from 'nutshell-graphql-types';

import CREATE_CUSTOM_FIELD from '../mutations/create-custom-field-per-pipeline.graphql';
import GET_CUSTOM_FIELDS from '../queries/get-custom-fields.graphql';

export const useCreateCustomField = (): {
    createCustomField: (input: CreateCustomFieldVariables, entityType: EntityType) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createCustomField, {loading, error}] = useMutation<
        CreateCustomFieldMutation,
        CreateCustomFieldVariables
    >(CREATE_CUSTOM_FIELD);

    return {
        createCustomField: (input: CreateCustomFieldVariables, entityType: EntityType) => {
            return createCustomField({
                variables: input,
                update: (proxy, {data}) => {
                    const customField =
                        data && data.createCustomField && data.createCustomField.customField;

                    if (!customField) return;

                    const customFields = proxy.readQuery({
                        query: GET_CUSTOM_FIELDS,
                        variables: {input: {entityType}},
                    });

                    if (!customFields) return;

                    proxy.writeQuery({
                        query: GET_CUSTOM_FIELDS,
                        variables: {input: {entityType}},
                        data: {
                            customFields: {
                                // @ts-expect-error
                                ...customFields.customFields,
                                // @ts-expect-error
                                active: [...customFields.customFields.active, customField],
                                // @ts-expect-error
                                archived: customFields.customFields.archived || [],
                            },
                        },
                    });
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
